// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_i1-6";
export var emphasizeQuantity = "_i1-3";
export var flatBottomCorners = "_i1-5";
export var productImage = "_i1-0";
export var quantityContainer = "_i1-2";
export var tooltip = "_i1-1";
export var wrapAndEllipsesOverflow = "_i1-4";